import type {PosterEditorTranscriptTextFillPanelProps} from '@Panels/poster-editor-transcript-text-fill-panel/poster-editor-transcript-text-fill-panel.types';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';

export const PANEL_ID = 'poster-editor-transcript-text-fill-panel';

export const openPosterEditorTranscriptTextFillModal = (props?: PosterEditorTranscriptTextFillPanelProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.POSTER_EDITOR_TRANSCRIPT_TEXT_FILL_MODAL,
      panelProps: {
        panelId: PANEL_ID,
        ...props,
      },
    })
  );
};
